import React, { FunctionComponent, memo } from 'react';
import { Grid } from '@material-ui/core';
import IExtendedFeaturesList from '../../../../../../model/IExtendedFeaturesList';
import { useCheckSelectedFeatures } from '../../../../../../hooks/features/useCheckSelectedFeatures';
import CheckboxOption from './CheckboxOption';
import customiseCheckboxOptionsStyles from './customiseCheckboxOptionsStyles';
import useCustomizeCarContext from '../../../../../../hooks/useCustomizeCarContext';

export interface IFeaturesListProps {
  featuresList: IExtendedFeaturesList;
}

const CustomiseCheckboxOptionsList: FunctionComponent<IFeaturesListProps> = memo(({ featuresList }) => {
  const styles = customiseCheckboxOptionsStyles();
  const { optimisticSelectedFeatures } = useCustomizeCarContext();
  const { handleCheckboxChange } = useCheckSelectedFeatures();

  return (
    <Grid className={styles.container} container={true} spacing={2} data-test={`options:container`}>
      {featuresList.features.map((feature, index) => (
        <CheckboxOption
          key={index}
          feature={feature}
          value={feature.code}
          handleChange={handleCheckboxChange}
          isChecked={optimisticSelectedFeatures.includes(feature.code)}
        />
      ))}
    </Grid>
  );
});

export default CustomiseCheckboxOptionsList;
